var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatLep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CEDFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.0022C22.1762 19.5014 22.524 19.079 22.9817 18.81C23.4395 18.5409 23.9777 18.4426 24.501 18.5324C25.0243 18.6221 25.499 18.8942 25.8409 19.3004C26.1829 19.7066 26.37 20.2207 26.3692 20.7517C26.3692 22.2506 24.1209 23 24.1209 23M24.1499 26H24.1599M19 30V32.3355C19 32.8684 19 33.1348 19.1092 33.2716C19.2042 33.3906 19.3483 33.4599 19.5005 33.4597C19.6756 33.4595 19.8837 33.2931 20.2998 32.9602L22.6852 31.0518C23.1725 30.662 23.4162 30.4671 23.6875 30.3285C23.9282 30.2055 24.1844 30.1156 24.4492 30.0613C24.7477 30 25.0597 30 25.6837 30H28.2C29.8802 30 30.7202 30 31.362 29.673C31.9265 29.3854 32.3854 28.9265 32.673 28.362C33 27.7202 33 26.8802 33 25.2V19.8C33 18.1198 33 17.2798 32.673 16.638C32.3854 16.0735 31.9265 15.6146 31.362 15.327C30.7202 15 29.8802 15 28.2 15H19.8C18.1198 15 17.2798 15 16.638 15.327C16.0735 15.6146 15.6146 16.0735 15.327 16.638C15 17.2798 15 18.1198 15 19.8V26C15 26.93 15 27.395 15.1022 27.7765C15.3796 28.8117 16.1883 29.6204 17.2235 29.8978C17.605 30 18.07 30 19 30Z",
    stroke: "#0860C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLep);
export default __webpack_public_path__ + "static/media/chat-lep.0b9d2dcb8b12740756172c737c178904.svg";
export { ForwardRef as ReactComponent };